export default {
  methods: {
    showSuccess(message) {
      this.$toasted.clear()
      this.$toasted.show('<i class="fas fa-check"></i>' + message, {
        type: 'success',
        duration: 5000
      })
    },
    showInfo(message) {
      this.$toasted.clear()
      this.$toasted.show('<i class="fas fa-info-circle"></i>' + message, {
        type: 'info',
        duration: 5000
      })
    },
    showError(message) {
      this.$toasted.clear()
      this.$toasted.show(
        '<i class="fas fa-exclamation-triangle"></i>' + message,
        {
          type: 'error',
          duration: 5000
        }
      )
    },
    isPWA() {
      const mqStandAlone = '(display-mode: standalone)'
      return (
        /Android/i.test(navigator.userAgent) &&
        document.defaultView.matchMedia(mqStandAlone).matches
      )
    },
    showAppDeprecated() {
      if (this.isPWA()) {
        this.$toasted.show(
          '<i class="fas fa-info-circle"></i>This app is deprecated.  Please migrate to the mobile website using your browser.<br/>https://www.airportviewer.com',
          {
            position: 'top-center',
            // fullWidth: true,
            action: {
              text: 'Dismiss',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            }
          }
        )
      }
    }
  }
}
